import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { PendingEditShape, ShapeState } from './shape.types';

import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { PredefinedShape } from '~/core/models';

const initialState: ShapeState = {
  selectedDrawingObjectName: '',
  selectedDrawingTab: DrawingTabEnum.MODIFY_PREDEFINED_SHAPE_TAB,
  selectedPredefinedShape: undefined,
  pendingEditShape: undefined,
};

const shapeSlice = createSlice({
  name: 'shape',
  initialState,
  reducers: {
    updateSelectedPredefinedShape: (
      state,
      action: PayloadAction<PredefinedShape>
    ) => {
      state.selectedPredefinedShape = action.payload;
    },
    resetSelectedPredefinedShape: (state) => {
      state.selectedPredefinedShape = initialState.selectedPredefinedShape;
      state.selectedDrawingObjectName = initialState.selectedDrawingObjectName;
    },
    updateSelectedDrawingTab: (
      state,
      action: PayloadAction<DrawingTabEnum>
    ) => {
      state.selectedDrawingTab = action.payload;
    },
    clearSelectedDrawingTabs: (state) => {
      state.selectedDrawingTab = undefined;
    },
    updateSelectedDrawingObjectName: (state, action: PayloadAction<string>) => {
      state.selectedDrawingObjectName = action.payload;
    },
    setPendingEditShape: (state, action: PayloadAction<PendingEditShape>) => {
      state.pendingEditShape = action.payload;
    },
    clearPendingEditShape: (state) => {
      state.pendingEditShape = undefined;
    },
  },
});

export const {
  updateSelectedPredefinedShape,
  resetSelectedPredefinedShape,
  updateSelectedDrawingObjectName,
  updateSelectedDrawingTab,
  clearSelectedDrawingTabs,
  setPendingEditShape,
  clearPendingEditShape,
} = shapeSlice.actions;

export default shapeSlice.reducer;
